import { useEffect, useState } from 'react'
import { GoogleMapWithRoutes, Modal } from 'stories/components'

type Function = () => void

interface PromptModalProps {
  /**
   * Title
   */
  title?: string | JSX.Element
  /**
   * Cancel button handler
   */
  onCancel?: Function
  /**
   * Is Open
   */
  isOpen?: boolean
  lastUpdatedAt: number
  options: { addresses: string[] }
}

/**
 * Primary UI component for user interaction
 */
export const MapDistanceModal = ({
  title = '',
  onCancel = () => {},
  isOpen: parentIsOpen = false,
  lastUpdatedAt,
  options,
}: PromptModalProps) => {
  const [isLoading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setShowModal(parentIsOpen)
  }, [lastUpdatedAt])

  if (!showModal) return null

  return (
    <>
      <Modal
        title={title}
        titleOkay=""
        loading={isLoading}
        isOpen={parentIsOpen}
        lastUpdatedAt={lastUpdatedAt}
        onClose={onCancel}
        childLevel={2}
      >
        <div className="min-w-[40rem] h-120">
          <GoogleMapWithRoutes addresses={options.addresses} setLoading={setLoading} />
        </div>
      </Modal>
    </>
  )
}
